import React, { useContext, useState } from "react";
import {
  DropdownSelect,
  Standard,
  RadioSelect,
  PhotoVideo,
  Info,
  Repeater,
  DvlaLookup,
  DamageMarker,
  Maps
} from "../../Components";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import "./formContainer.scss";
import { DataContext } from "../../js/App";


const FormContainer = ({ index, fields, appendName, labelName }) => {
  //     const [validated, setValidated] = useState(false);

  //     const handleSubmit = (event) => {
  //     const form = event.currentTarget;
  //     if (form.checkValidity() === false) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //     }

  //     setValidated(true);
  //   };
  const context = useContext(DataContext);
  const { formValues, activeTab, navArray, setActiveTab, handleRequiredField } = context;
  const additionalStyling = index === 0 ? "" : "";
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const goToPreviousPage = () => {
    const actualIndex = navArray.indexOf(activeTab);
    setActiveTab(actualIndex !== 0 ? navArray[actualIndex - 1] : navArray[0]);
  };
  const goToNextPage = () => {
    const actualIndex = navArray.indexOf(activeTab);
    setActiveTab(actualIndex !== navArray.length - 1 ? navArray[actualIndex + 1] : "overview");
  };

  const resetForm = () => {
    window.location.reload();
  }

  let componentFields = [];

  fields.forEach((field) => {
    let componentField;
    const name = typeof appendName !== 'undefined' ? appendName + field.name : field.name;
    const parentName = typeof appendName !== 'undefined' ? appendName : "";
    const fieldLabel = field.required ? field.label + "*" : field.label;
    let showField = true;
    const fieldOptions = field.options ?? null;

    const addText = fieldOptions && fieldOptions.addText ? fieldOptions.addText : "Add new";
    const title = fieldOptions && fieldOptions.title ? fieldOptions.title : "";
    const labelPlaceholder = fieldOptions && fieldOptions.labelPlaceholder ? fieldOptions.labelPlaceholder : false;
    const currentValue = name in formValues ? formValues[name] : null;

    if(fieldOptions && fieldOptions.skipField){
      return;
    }
    if (field.required) {
      handleRequiredField(name);
    }

    if (fieldOptions &&
      typeof fieldOptions.related !== 'undefined' &&
      typeof fieldOptions.relatedOptions !== 'undefined' &&
      fieldOptions.related !== null &&
      fieldOptions.relatedOptions !== null
    ) {
      if (typeof formValues !== 'undefined' &&
        typeof formValues[parentName + fieldOptions.relatedOptions.field] !== 'undefined' &&
        formValues[parentName + fieldOptions.relatedOptions.field].toLowerCase() === fieldOptions.relatedOptions.value.toLowerCase()
      ) {
        showField = true;
      } else {
        showField = false;
      }
    }

    if (showField) {
      switch (field.type) {
        case "text":
        case "date":
        case "time":
        case "textarea":
          componentField = (
            <Standard
              name={name}
              key={field.id}
              fieldLabel={fieldLabel}
              type={field.type}
              placeholder={field.placeholder}
              labelPlaceholder={labelPlaceholder}
              defaultValue={currentValue}
            />
          );
          break;
        case "select":
          field.options &&
            field.options.options &&
            field.options.options.length === 2
            ? (componentField = (
              <RadioSelect
                name={name}
                fieldLabel={fieldLabel}
                type={"radio"}
                options={field.options}
              />
            ))
            : (componentField = (
              <DropdownSelect
                name={name}
                fieldLabel={fieldLabel}
                options={field.options.options}
                labelPlaceholder={labelPlaceholder}
                placeholder={field.placeholder}
              />
            ));
          break;
        case "image":
        case "video":
        case "image-repeater":
          componentField = (
            <PhotoVideo
              name={name}
              type={field.type === "image-repeater" ? "image" : field.type}
              placeholder={field.placeholder}
              labelPlaceholder={labelPlaceholder}
            />
          );
          break;
        case "map-confirm":
        componentField = (
          <Maps
            fieldLabel={fieldLabel}
            name={name}
          />
        );
        break;
        case "info":
          const isTitle = field.options && field.options.isTitle ? field.options.isTitle : false;
          componentField = (
            <Info
              name={name}
              fieldLabel={fieldLabel}
              placeholder={field.placeholder}
              isTitle={isTitle}
            />
          );
          break;
        case "checkbox":
          componentField = (
            <RadioSelect
              name={name}
              fieldLabel={fieldLabel}
              type={"checkbox"}
              options={field.options.options}
            />
          );
          break;
        case "repeater":
          componentField = (
            <Repeater
              name={name}
              fieldLabel={fieldLabel}
              options={field.options}
              addText={addText}
              title={title}
            />
          );
          break;
        case "dvla":
          componentField = (
            <DvlaLookup
              name={name}
              fieldLabel={fieldLabel}
              parentName={parentName}
            />
          );
          break;
        case "advanced-damage":
          componentField = (
            <DamageMarker
              name={name}
              fieldLabel={fieldLabel}
              parentName={parentName}
            />
          );
          break;
        default:
          componentField = null;
      }
      componentField !== null && componentFields.push(componentField);
    }
  });

  if (typeof appendName === 'undefined') {
    return (
      <Form>
        {componentFields.map((componentField, index) => (
          <React.Fragment key={index}>{componentField}</React.Fragment>
        ))}
        <div className={`buttonContainer ${additionalStyling}`}>
          {navArray && navArray.indexOf(activeTab) > 0 && (
            <Button variant="outline-primary" onClick={() => goToPreviousPage()}>Back</Button>
          )}

          {navArray && navArray.indexOf(activeTab) === 0 && (<>
            <Button variant="outline-primary" onClick={() => handleShow()}>Reset Form</Button>
            <Modal show={show} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Reset form</Modal.Title>
              </Modal.Header>
              <Modal.Body>If you reset the form, all the data inserted will be lost.</Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                  No
                </Button>
                <Button variant="danger" onClick={() => resetForm()}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </>
          )}

          <Button variant="primary" onClick={() => goToNextPage()}>Next</Button>
        </div>
      </Form>
    );
  } else {
    return (<>
      <h2>{labelName}</h2>
      {componentFields.map((componentField, index) => (
        <React.Fragment key={index}>{componentField}</React.Fragment>
      ))}
    </>);
  }

};

export default FormContainer;
